<template>
	<div class="shindanpage">
		<SpinnerShow :active="isLoading" text="Loading……!!" />
		<div class="spinner">
			<!-- <Spinner :isLoading="isLoading" /> -->
			<vue-element-loading :active="show" is-full-screen />
			<div v-show="input">
				<h3>お客様情報</h3>
				<h3 class="errmsg" v-show="errmsg">必須項目を入力して下さい</h3>
				<div>
					<span class="hissu">*</span>
					<Headline Headline="会社名または店舗名" />
				</div>
				<div class="inputtext">
					<input :value="company" type="text" class="form-control" maxlength="25"
						v-bind:class="{ 'alert-color': isActive.company_check }"
						@input="company = $event.target.value" />
				</div>
				<div>
					<span class="hissu">*</span>
					<Headline Headline="ご担当者様お名前" />
				</div>
				<div class="inputtext">
					<input :value="name" type="text" class="form-control" maxlength="25"
						v-bind:class="{ 'alert-color': isActive.name_check }" @input="name = $event.target.value" />
				</div>
				<div>
					<Headline Headline="部署名" />
				</div>
				<div class="inputtext">
					<input :value="busyo" type="text" class="form-control" maxlength="25"
						@input="busyo = $event.target.value" />
				</div>
				<div>
					<span class="hissu">*</span>
					<Headline Headline="ご連絡先（電話番号）" />
				</div>
				<div class="inputtext">
					<input :value="tel" type="number" placeholder="例）09012345551" class="form-control" maxlength="25"
						v-bind:class="{ 'alert-color': isActive.tel_check }" @input="tel = $event.target.value" />
				</div>
				<div>
					<span class="hissu">*</span>
					<Headline Headline="メールアドレス" />
				</div>
				<div class="inputtext">
					<input :value="mail" type="email" placeholder="例）star@gmail.com" class="form-control" maxlength="50"
						v-bind:class="{ 'alert-color': isActive.mail_check }" @input="mail = $event.target.value" />
				</div>
				<Headline Headline="業種" />
				<DropDown />
				<h3>質問事項</h3>
				<Headline Headline="1.サイボウズデイズ2024にはどのような目的で来場されましたか？（複数選択可）" />
				<CheckBox class="" CheckBox="kintoneの調査、検討" For="kintonetyousa"
					:ischecked="this.checkbox.includes('kintoneの調査、検討')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="その他サイボウズサービスの調査、検討" For="cybozutyousa"
					:ischecked="this.checkbox.includes('その他サイボウズサービスの調査、検討')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="各社プラグインの調査、検討" For="plugin"
					:ischecked="this.checkbox.includes('各社プラグインの調査、検討')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="その他の来場目的" For="raizyousonota"
					:ischecked="this.checkbox.includes('その他の来場目的')" @change="setCheckbox" />

				<Headline Headline="2.あなたはkintoneの導入において、貴社内でどのような立場ですか？" />
				<RadioBtn v-model="selectedValue" name="group1" value="導入を承認する立場" label="導入を承認する立場" For="tatiba1" />
				<RadioBtn v-model="selectedValue" name="group1" value="導入を検討する立場" label="導入を検討する立場" For="tatiba2" />
				<RadioBtn v-model="selectedValue" name="group1" value="導入を提案する立場" label="導入を提案する立場" For="tatiba3" />
				<RadioBtn v-model="selectedValue" name="group1" value="その他" label="その他" For="tatiba4" />

				<Headline Headline="3.kintoneは導入されていらっしゃいますか？" />
				<RadioBtn v-model="selectedValue2" name="group2" value="導入済み" label="導入済み" For="kintonedounyu1" />
				<RadioBtn v-model="selectedValue2" name="group2" value="調査、検討中" label="調査、検討中" For="kintonedounyu2" />
				<RadioBtn v-model="selectedValue2" name="group2" value="興味なし" label="興味なし" For="kintonedounyu3" />
				<RadioBtn v-model="selectedValue2" name="group2" value="その他" label="その他" For="kintonedounyu4" />

				<Headline Headline="4.3でkintoneをすでに導入済みとお答えになられた方は、kintoneに対するお悩みやご不満はございますか？" />
				<RadioBtn v-model="selectedValue4" name="group4" value="ある" label="ある" For="human1" />
				<RadioBtn v-model="selectedValue4" name="group4" value="ない" label="ない" For="human2" />
				<RadioBtn v-model="selectedValue4" name="group4" value="わからない" label="わからない" For="human3" />

				<Headline Headline="5.4であるとお答えになられた方は、どのようなお悩みやご不満がございますか？（複数選択可）" />
				<CheckBox class="" CheckBox="kintoneを導入したがうまく使えていない" For="notuse"
					:ischecked="this.checkbox.includes('kintoneを導入したがうまく使えていない')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="コスパ、タイパが悪いような気がする" For="batcost"
					:ischecked="this.checkbox.includes('コスパ、タイパが悪いような気がする')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="他のシステムとの連携ができない" For="notrenkei"
					:ischecked="this.checkbox.includes('他のシステムとの連携ができない')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="使い方がわからない" For="useqa" :ischecked="this.checkbox.includes('使い方がわからない')"
					@change="setCheckbox" />
				<CheckBox class="" CheckBox="パートナー企業を探している" For="lookingkigyou"
					:ischecked="this.checkbox.includes('パートナー企業を探している')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="自社kintone環境の診断をしてほしい" For="wantshindan"
					:ischecked="this.checkbox.includes('自社kintone環境の診断をしてほしい')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="最適な提案をしてほしい" For="wantteian"
					:ischecked="this.checkbox.includes('最適な提案をしてほしい')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="その他" For="humansonota" :ischecked="this.checkbox.includes('その他')"
					@change="setCheckbox" />


				<Headline Headline="6.どんな悩みをお持ちですか?" />
				<CheckBox class="centerleft" CheckBox="顧客・案件管理" For="nayamiKokyaku"
					:ischecked="this.checkbox.includes('顧客・案件管理')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="企業間のやりとり" For="nayamiYaritori"
					:ischecked="this.checkbox.includes('企業間のやりとり')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="脱Excel" For="nayamiExcel" :ischecked="this.checkbox.includes('脱Excel')"
					@change="setCheckbox" />
				<CheckBox class="" CheckBox="ワークフロー_申請業務" For="nayamiWorkfuro"
					:ischecked="this.checkbox.includes('ワークフロー_申請業務')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="受発注管理_悩み" For="nayamiZyuhatyu"
					:ischecked="this.checkbox.includes('受発注管理_悩み')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="リモートワーク" For="nayamiRimoto" :ischecked="this.checkbox.includes('リモートワーク')"
					@change="setCheckbox" />
				<CheckBox class="" CheckBox="日報・報告書_悩み" For="nayamiNippou"
					:ischecked="this.checkbox.includes('日報・報告書_悩み')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="プロジェクト管理" For="nayamiPro" :ischecked="this.checkbox.includes('プロジェクト管理')"
					@change="setCheckbox" />
				<CheckBox class="" CheckBox="基幹システムとのデータ連携" For="nayamiKikan"
					:ischecked="this.checkbox.includes('基幹システムとのデータ連携')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="問い合わせ管理_悩み" For="nayamiToiawase"
					:ischecked="this.checkbox.includes('問い合わせ管理_悩み')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="ファイル管理_悩み" For="nayamiFile"
					:ischecked="this.checkbox.includes('ファイル管理_悩み')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="売上管理_悩み" For="nayamiUriage" :ischecked="this.checkbox.includes('売上管理_悩み')"
					@change="setCheckbox" />
				<CheckBox class="" CheckBox="採用管理_悩み" For="nayamiSaiyou" :ischecked="this.checkbox.includes('採用管理_悩み')"
					@change="setCheckbox" />
				<CheckBox class="" CheckBox="社内ポータル_悩み" For="nayamiSyanai"
					:ischecked="this.checkbox.includes('社内ポータル_悩み')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="アンケート・調査" For="nayamiAnketo"
					:ischecked="this.checkbox.includes('アンケート・調査')" @change="setCheckbox" />
				<CheckBox class="" CheckBox="QFA_悩み" For="QFA" :ischecked="this.checkbox.includes('QFA_悩み')"
					@change="setCheckbox" />


				<Headline Headline="7.ご回答いただいたお客様のお悩みや問題点が解決できるサービスをご紹介・ご提案させていただいてもよろしいでしょうか？" />
				<RadioBtn v-model="selectedValue3" name="group3" value="はい" label="はい" For="syoukai1" />
				<RadioBtn v-model="selectedValue3" name="group3" value="いいえ" label="いいえ" For="syoukai2" />

				<BtnNomal BtnNomal="入力内容確認" @click="kakuninBtn()" />
			</div>
			<div v-show="kakunin">
				<!-- ここから確認画面 -->
				<h3>お客様情報</h3>
				<Headline Headline="会社名または店舗名" />
				<Kakunin :Kakunin="this.company" />
				<Headline Headline="ご担当者様お名前" />
				<Kakunin :Kakunin="this.name" />
				<Headline Headline="部署名" />
				<Kakunin :Kakunin="this.busyo" />
				<Headline Headline="ご連絡先（電話番号）" />
				<Kakunin :Kakunin="this.tel" />
				<Headline Headline="メールアドレス" />
				<Kakunin :Kakunin="this.mail" />
				<Headline Headline="業種" />
				<Kakunin :Kakunin="this.selected" />
				<h3>質問事項</h3>
				<Headline Headline="1.サイボウズデイズ2024にはどのような目的で来場されましたか？（複数選択可）" />
				<!-- t -->
				<div class="left-checkbox">
					<ul id="club_treatments">
						<li v-for="item in this.raizyou_list" :key="item">・{{ item }}</li>
					</ul>
				</div>

				<Headline Headline="2. あなたはkintoneの導入において、貴社内でどのような立場ですか？" />
				<Kakunin :Kakunin="this.selectedValue" />

				<Headline Headline="3. kintoneは導入されていらっしゃいますか？" />
				<Kakunin :Kakunin="this.selectedValue2" />

				<Headline Headline="4.3でkintoneをすでに導入済みとお答えになられた方は、kintoneに対するお悩みやご不満はございますか？" />
				<!-- t -->
				<Kakunin :Kakunin="this.selectedValue4" />

				<Headline Headline="5.4であるとお答えになられた方は、どのようなお悩みやご不満がございますか？（複数選択可）" />
				<!-- t -->
				<div class="left-checkbox">
					<ul id="club_treatments">
						<li v-for="item in this.human_list" :key="item">・{{ item }}</li>
					</ul>
				</div>

				<Headline Headline="6.どんな悩みをお持ちですか?" />
				<!-- t -->
				<div class="left-checkbox">
					<ul id="club_treatments">
						<li v-for="item in this.nayami_list" :key="item">・{{ item }}</li>
					</ul>
				</div>
				<Headline Headline="7.ご回答いただいたお客様のお悩みや問題点が解決できるサービスをご紹介・ご提案させていただいてもよろしいでしょうか？" />
				<Kakunin :Kakunin="this.selectedValue3" />

				<BtnNomal BtnNomal="送信" @click="post()" />
				<BtnNomal BtnNomal="戻る" @click="back()" />
			</div>
		</div>
	</div>
</template>

<script>
import CheckBox from "@/atoms/CheckBox.vue";
import Headline from "@/atoms/Headline.vue";
import BtnNomal from "@/atoms/BtnNomal.vue";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/main";
import DropDown from "../atoms/DropDown.vue";
import Kakunin from "@/atoms/Kakunin.vue";
import SpinnerShow from "@/atoms/SpinnerShow.vue";
import RadioBtn from "@/atoms/RadioBtn.vue";
// import Spinner from "@/atoms/spinner.vue";
export default {
	name: "CybozuDays2024",
	components: {
		CheckBox,
		Headline,
		BtnNomal,
		DropDown,
		Kakunin,
		SpinnerShow,
		RadioBtn
		// Spinner,
	},
	data() {
		return {
			company: this.company,
			name: this.name,
			busyo: this.busyo,
			tel: this.tel,
			mail: this.mail,
			selected: this.Dropdown,
			checkbox: [],
			nayami_list: [],
			raizyou_list: [],
			human_list: [],
			henshushow: true,
			input: true,
			kakunin: false,
			isLoading: false,
			errmsg: false,
			isActive: {
				company_check: false,
				name_check: false,
				busyo_check: false,
				tel_check: false,
				mail_check: false,
			},
			selectedValue: '導入を承認する立場',//あなたはkintoneの導入において、貴社内でどのような立場ですか？
			selectedValue2: '導入済み',//kintoneは導入されていらっしゃいますか？
			selectedValue3: 'はい',
			selectedValue4: 'ある',
		};
	},
	methods: {
		setCheckbox(checkObj) {
			console.log(checkObj);
			if (checkObj.ischecked === true) {
				this.checkbox.push(checkObj.checkboxName);
			} else {
				let index = this.checkbox.indexOf(checkObj.checkboxName);
				if (index >= 0) {
					this.checkbox.splice(index, 1);
				}
			}
			// console.log(this.checkbox);
		},
		// 未入力チェック
		isInValid(mozi) {
			// console.log("未入力チェック");
			// console.log(mozi);
			if (mozi === undefined || mozi === "") {
				return true;
			}
			return false;
		},
		// メールアドレス
		isInValidEmail(mail) {
			// console.log("チェックメール");
			//メールアドレスとして判定される文字列と記号の組み合わせを定数化
			const reg = new RegExp(
				/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
			);
			//指定した組み合わせになっていなかった場合判定を返す。
			return !reg.test(mail);
		},
		async kakuninBtn() {
			/**
			 * 入力チェック
			 */
			let companyName = await this.isInValid(this.company);
			let name_hito = this.isInValid(this.name);
			let tel = this.isInValid(this.tel);
			let mail = this.isInValidEmail(this.mail);
			if (
				companyName === true ||
				name_hito === true ||
				tel === true ||
				mail === true
			) {
				//未入力があるため遷移できない
				this.errmsg = true;
			} else {
				this.kakunin = true;
				this.input = false;
				this.errmsg = false;
			}
			if (companyName === true) {
				//会社名
				this.isActive.company_check = true;
			} else {
				this.isActive.company_check = false;
			}
			if (name_hito === true) {
				//担当者
				this.isActive.name_check = true;
			} else {
				this.isActive.name_check = false;
			}
			if (tel === true) {
				//電話番号
				this.isActive.tel_check = true;
			} else {
				this.isActive.tel_check = false;
			}
			if (mail === true) {
				//メールアドレス
				this.isActive.mail_check = true;
			} else {
				this.isActive.mail_check = false;
			}
			//TOPに戻る
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
			let nayami_list = [];
			let raizyou_list = [];
			let human_list = [];
			this.checkbox.forEach(function (element) {
				if (
					//6.どんな悩みをお持ちですか?
					element === "顧客・案件管理" ||
					element === "企業間のやりとり" ||
					element === "脱Excel" ||
					element === "ワークフロー_申請業務" ||
					element === "受発注管理_悩み" ||
					element === "リモートワーク" ||
					element === "日報・報告書_悩み" ||
					element === "プロジェクト管理" ||
					element === "基幹システムとのデータ連携" ||
					element === "問い合わせ管理_悩み" ||
					element === "ファイル管理_悩み" ||
					element === "売上管理_悩み" ||
					element === "採用管理_悩み" ||
					element === "社内ポータル_悩み" ||
					element === "アンケート・調査" ||
					element === "QFA_悩み"
				)
					nayami_list.push(element);
				if (
					//1.サイボウズデイズ2024にはどのような目的で来場されましたか？（複数選択可）
					element === "kintoneの調査、検討" ||
					element === "その他サイボウズサービスの調査、検討" ||
					element === "各社プラグインの調査、検討" ||
					element === "その他の来場目的"
				)
					raizyou_list.push(element);
				if (
					//6.どんな悩みをお持ちですか?
					element === "kintoneを導入したがうまく使えていない" ||
					element === "コスパ、タイパが悪いような気がする" ||
					element === "他のシステムとの連携ができない" ||
					element === "使い方がわからない" ||
					element === "パートナー企業を探している" ||
					element === "自社kintone環境の診断をしてほしい" ||
					element === "最適な提案をしてほしい" ||
					element === "その他"
				)
					human_list.push(element);
			});
			this.nayami_list = nayami_list;
			this.raizyou_list = raizyou_list;
			this.human_list = human_list;
		},
		back() {
			this.kakunin = false;
			this.input = true;
		},
		async post() {
			this.isLoading = true;
			const kntn_func = httpsCallable(functions, "api/kintone/new");
			// console.log(kntn_func);

			let record = {
				txt_会社名または店舗名: { value: this.company },
				drp_業種: { value: this.selected },
				txt_ご担当者様お名前: { value: this.name },
				txt_部署名: { value: this.busyo },
				lik_電話番号: { value: this.tel },
				lik_メールアドレス: { value: this.mail },
				chk_悩み: { value: this.nayami_list },
				chk_サイボウズデイズ2024にはどのような目的で来場: { value: this.raizyou_list },//来場目的
				rdo_kintoneに対するお悩みやご不満: { value: this.selectedValue4 },//4.3でkintoneをすでに導入済みとお答えになられた方は、kintoneに対するお悩みやご不満はございますか？
				chk_お悩みやご不満: { value: this.human_list },//5.4であるとお答えになられた方は、どのようなお悩みやご不満がございますか？（複数選択可）
				rdo_kintoneの導入においての立場: { value: this.selectedValue },
				rdo_kintone導入: { value: this.selectedValue2 },
				rdo_ご紹介ご提案: { value: this.selectedValue3 },
			};
			// let record = {};
			let resp = await kntn_func({ record: record });
			console.log(resp);
			if (resp.data.status === "error") {
				setTimeout(() => {
					this.isLoading = false;
				}, 500);
				console.log("エラーです");
			} else {
				setTimeout(() => {
					this.isLoading = false;
				}, 500);
				this.$router.push("/thanks").catch(() => { });
			}
			setTimeout(() => {
				this.isLoading = false;
			}, 500);
		},
	},
	async mounted() {
		// this.test();
	},
};
</script>

<style scoped>
.shindanpage {
	background-color: #fff;
	/* padding: 1%; */
}

h3 {
	color: #0d263d;
	font-size: 150%;
}

textarea {
	resize: none;
	width: 70%;
	height: 250px;
	border-radius: 10px;
	font-size: 1.5em;
}

textarea:valid {
	border: 3px solid #696773;
	/* border-radius: 10px; */
}

textarea:focus {
	border: solid 4px #77a88d;
	outline: 0;
}

input {
	resize: none;
	width: 70%;
	border-radius: 10px;
	font-size: 1.5em;
}

input:valid {
	border: 3px solid #696773;
	/* border-radius: 10px; */
}

input:focus {
	border: solid 4px #77a88d;
	outline: 0;
}

ul {
	padding-left: 0;
}

li {
	list-style: none;
}

li {
	list-style: none;
	padding-left: 15%;
	text-align: start;
	font-size: 20px;
}

span.hissu {
	float: right;
	padding-right: 65%;
	font-size: 25px;
	color: hsl(340.62deg 71% 58%);
}

h3.errmsg {
	color: hsl(340.62deg 71% 58%);
}

input.form-control.alert-color {
	border: 3px solid #c50d66;
	/* height: 25px; */
}

@media screen and (max-width: 480px) {

	/* 480px以下に適用されるCSS（スマホ用） */
	input {
		resize: none;
		width: 90%;
		border-radius: 10px;
		font-size: 1.5em;
	}

	.midashi {
		padding-left: 3%;
		text-align: left;
	}

	textarea {
		resize: none;
		width: 90%;
		height: 250px;
		border-radius: 10px;
		font-size: 1.5em;
	}

	.left {
		padding-left: 3%;
		text-align: left;
	}

	li {
		list-style: none;
		padding-left: 3%;
		text-align: start;
		font-size: 20px;
	}

	.inputtext {
		width: 100%;
	}

	span.hissu {
		float: right;
		padding-right: 35%;
		font-size: 25px;
		color: hsl(340.62deg 71% 58%);
	}
}
</style>